import { render, staticRenderFns } from "./fullname-cell.vue?vue&type=template&id=17774dd0&scoped=true&"
import script from "./fullname-cell.vue?vue&type=script&lang=js&"
export * from "./fullname-cell.vue?vue&type=script&lang=js&"
import style0 from "./fullname-cell.vue?vue&type=style&index=0&id=17774dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17774dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17774dd0')) {
      api.createRecord('17774dd0', component.options)
    } else {
      api.reload('17774dd0', component.options)
    }
    module.hot.accept("./fullname-cell.vue?vue&type=template&id=17774dd0&scoped=true&", function () {
      api.rerender('17774dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table/violations/fullname-cell.vue"
export default component.exports